import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        <h2 className="underline font-22">Ethical Code of Practice</h2>
        <br />
        The JD Sports Fashion Plc Ethical Code of practice is to establish a procedure for protecting workers and
        providing assurance that our products are manufactured within safe and fair conditions. The Ethical Code of
        Practice applies to everything we do and forms part of the contract with us. The people working for our
        suppliers are to be treated with respect, and their health and safety and basic human rights must be protected
        and promoted. To find out more about our Ethical Code of Practice, please read the report below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/JD-Group-Ethical-Code-of-Practice-2021.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="modern-slavery/code-of-practice.png" />
                    Code of Practice
                </a>
            </li>
        </ul>
        <h2 className="underline font-22">Code of Practice Auditing Standards</h2>
        <br />
        The JD Group Code of Conduct defines labour standards that aim to achieve decent and human working conditions.
        The principles incorporated within this Code of Conduct are based on the International Labour Organisation
        Standards and internationally accepted good labour practices.
        <br />
        <br />
        The Code of Practice Auditing standards is a guide that is referenced during site visits to our private label
        supply chain to assist in the evaluation process and identified in the JD code of conduct. This audit scope can
        be found in the pdf document below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/JD-Group-Audit-Scope-Document.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="modern-slavery/code-of-practice.png" />
                    Code of Practice Auditing Standards
                </a>
            </li>
        </ul>
        Where we have found instances of non-compliance through an audit, these are logged via a Non-Compliance
        Disclosure Report. We then work with the factory to quickly resolve any issues. The Non-Compliance Disclosure
        Report for audits conducted from June 2020 – June 2021 can be accessed below:
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/JD-Group-Non-Compliance-Disclosure-Document.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <PDFIcon name="modern-slavery/code-of-practice.png" />
                    Non-Compliance Disclosure Report
                </a>
            </li>
        </ul>
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/code-of-conduct.jpg',
    body: Body,
};
